import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FirebaseDataService } from "src/services/Firebase/data";
import { getUserData } from "src/redux/selectors/user";
import { DynamicOptions } from "src/components/molecules/DynamicForms/types";
import { DBVendor } from "src/types";

interface UseDynamicDropdownDataOptions {
  id: string;
}

export const useDynamicDropdownData = (options?: UseDynamicDropdownDataOptions) => {
  const [dropdownOptions, setDropdownOptions] = useState<DynamicOptions[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { id: userId } = useSelector(getUserData);

  useEffect(() => {
    if (!options?.id) {
      setDropdownOptions([]);
      return;
    }

    const fetchData = async () => {
      try {
        setIsLoading(true);
        setError(null);

        // Handle different data fetch types based on the ID
        if (options.id === "vendor") {
          const vendorResponse = await FirebaseDataService.getEmployeeVendors(userId);
          if (vendorResponse?.data) {
            const formattedOptions: DynamicOptions[] = vendorResponse.data.map((vendor: DBVendor) => ({
              label: vendor.name,
              value: vendor.id,
            }));
            setDropdownOptions(formattedOptions);
          }
        } else if (options.id === "poType") {
          // Purchase Order Type options
          const poTypeOptions: DynamicOptions[] = [
            { label: "Consignment", value: "CONSIGNMENT" },
            { label: "Parts", value: "PARTS" },
            { label: "Service", value: "SERV" },
            { label: "Standard", value: "STD" },
          ];
          setDropdownOptions(poTypeOptions);
        }
        // Add more cases here for other dropdown types as needed

        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching dropdown data:", err);
        setError(err instanceof Error ? err.message : "Failed to load dropdown data");
        setIsLoading(false);
      }
    };

    fetchData();
  }, [options?.id, userId]);

  return { dropdownOptions, isLoading, error };
};
